module.exports = __webpack_public_path__ + "static/media/leave.379b259c.svg";